import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    promos: 'max-xs:flex-col flex items-start gap-4',
    bonuses: 'flex flex-col gap-2 lg:gap-2.5',
    bonusToggle: 'mt-3 flex items-center',
    bonusAmount: 'flex items-center justify-between',
    bonusValue: 'heading-xl',
    bonusLabel: '!heading-m-bold',
    promo: 'w-full',
    certificate: 'w-full',
    tab: 'text-s hover:bg-brand-400 h-11.5 w-1/2 rounded-none border-0 font-medium normal-case max-md:px-3 max-md:leading-[120%] max-md:whitespace-normal last:max-md:text-left hover:[&_svg:nth-of-type(1)]:hidden [&_svg:nth-of-type(2)]:hidden hover:[&_svg:nth-of-type(2)]:block',
    tabs: 'rounded-none',
    activeTab:
      'bg-brand-400 text-text-main-inversion [&_svg:nth-of-type(1)]:hidden [&_svg:nth-of-type(2)]:block',
    tabsWrap: 'gap-1 bg-white p-2',
    bonusIcon: 'h-5 w-5 max-md:h-6 max-md:w-6',
    tabTitle: 'flex items-center justify-center gap-1 max-md:gap-2'
  }
});
